import FileSaver from "file-saver";
import { downloadFile } from "../../infrastructure/repository/public-requests-repository";
import { showErrorMessage } from "../commons/show-error-message";
import { translate as t } from "../../infrastructure/translate/localization";

export default async function downLoadRentingStepFile({
  fileId,
  fileName,
}: {
  fileId: string;
  fileName: string;
}): Promise<void> {
  try {
    const { data } = await downloadFile({
      fileId,
    });
    FileSaver(data, fileName);
  } catch (error) {
    showErrorMessage(t("common-messages.basic-error-message"));
  }
}
